export default function CoorayFooter(
    {
        background = "bg-base-100"
    }
) {
    return (
        <footer className={`footer px-4 pt-8 pb-16 ${background} text-base-content footer-horizontal footer-center`}>
        <aside>
            {/* <img src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/transparent-bear.png" className="h-28 w-28"/> */}
            
            <p><span className="font-bold">
            Zipmap
            </span> Copyright © 2025 - All rights reserved</p>
        </aside> 
        </footer>
    )
}